export const blockIconsCommunicationHub = (
	<span className='material-symbols-outlined'>hub</span>
);
